export default __webpack_public_path__ + "static/media/96_mobile.c310f74c.jpg";